var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 177",
    style: {
      enableBackground: "new 0 0 136 177"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.26,35.69h-13.31c-2.2,0-4-2.09-4-4.66V19.05c0-8.45-6.57-15.31-14.64-15.31H19.74c-8.08,0-14.65,6.86-14.65,15.31 v139.79c0,8.44,6.57,15.31,14.65,15.31h98.52c8.08,0,14.64-6.87,14.64-15.31V51C132.9,42.56,126.33,35.69,118.26,35.69z  M122.25,158.84c0,2.57-1.79,4.66-4,4.66H19.74c-2.2,0-4-2.09-4-4.66V19.05c0-2.57,1.79-4.66,4-4.66h66.57 c2.2,0,3.99,2.09,3.99,4.66v11.98c0,8.45,6.57,15.31,14.64,15.31h13.31c2.2,0,4,2.09,4,4.66V158.84z M106.27,110.25H31.72 c-2.94,0-5.33,2.38-5.33,5.32c0,2.94,2.38,5.33,5.33,5.33h74.56c2.94,0,5.33-2.39,5.33-5.33 C111.6,112.64,109.22,110.25,106.27,110.25z M106.27,131.55H31.72c-2.94,0-5.33,2.38-5.33,5.33c0,2.94,2.38,5.32,5.33,5.32h74.56 c2.94,0,5.33-2.38,5.33-5.32C111.6,133.93,109.22,131.55,106.27,131.55z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.82,92.84c0.9,1.12,0.84,1.8-0.22,2.75l-2.13,1.74c-0.96,0.84-1.85,0.73-2.7-0.22l-3.65-4.33 c-2.13,1.01-4.77,1.52-7.86,1.52c-10.28,0-16.06-5.5-16.06-14.66V67.4c0-9.15,5.78-14.66,16.06-14.66 c10.17,0,16.01,5.5,16.01,14.66v12.24c0,3.76-0.96,6.85-2.81,9.26L64.82,92.84z M39.27,79.69c0,5.22,3.2,8.03,8.99,8.03 c5.78,0,8.99-2.86,8.99-8.03V67.34c0-5.17-3.2-8.03-8.99-8.03c-5.78,0-8.99,2.81-8.99,8.03V79.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,91.6c0.45,1.24,0,1.85-1.29,1.85h-2.92c-2.3,0-3.03-0.34-3.48-1.69l-2.58-7.24h-15.5l-2.64,7.24 c-0.45,1.35-1.18,1.69-3.48,1.69h-2.58c-1.29,0-1.74-0.62-1.29-1.85L83.1,55.1c0.51-1.29,1.01-1.57,2.36-1.57h2.97 c1.35,0,1.91,0.34,2.36,1.52L104.83,91.6z M88.32,66.89c-0.67-2.02-1.12-4.6-1.29-5.9l-0.05-0.96h-0.39c0,2.14-0.39,4.38-1.23,6.8 l-4.33,11.91h11.57L88.32,66.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQa);
export default __webpack_public_path__ + "static/media/newQa.04d3724502c67c5f680cff5a634a25e5.svg";
export { ForwardRef as ReactComponent };